// import React from 'react'

// export default function Dashboard() { 

//   return (
//     <div>Dashboard</div>
//   )
// }


import { useNavigate, Link } from "react-router-dom";
import useLogout from "../hooks/useLogout";
import useAuth from "../hooks/useAuth";
import { Container, Row, Col } from 'react-bootstrap';
import "../pages/Admin/AdminDashboard.css";
import "../pages/Admin/Admin.css";
import 'boxicons/css/boxicons.min.css';
import TopBar from "../pages/Admin/TopBar";

const Dashboard = () => {
    const navigate = useNavigate();
    const logout = useLogout();
    const { auth } = useAuth();

    const signOut = async () => {
        await logout();
        navigate('/login');
    }

    return (

        <Container>
            {/* <div className="dashhead">
                <Row>
                    <Col><h5 className="dashhe">Dashboard</h5></Col>
                    <Col>
                    <div className="dashdiv">
                    <strong><i className="bx bxs-user icon dashicon"></i></strong> {auth?.name} / 
                    
                    <Link onClick={signOut} className="dashsign"><strong> <i className="bx bx-log-out icon dashiconr"></i></strong>  Sign Out</Link> 
                    </div>
                    </Col>
                </Row>
            </div> */}

            <section className="adminsec">

                <div className="center-image">

                    <img src="/images/newlogo.png" width="20%" className='' />
                </div>
                {/* <h1 className="adminhead">Dashbord</h1> */}
                <br />
                <center><h2 className="dashwel">WELCOME <span className="colorChange">{auth?.name}</span> !</h2> </center>
                {/* <p className="adminuse">Welcome {auth?.name} !</p> */}
                <br />

                <Row>

                    <Col md={4}>
                        <Link to="/admin/list/VibhagSummary/">
                            <div className="adminst">
                                <i className="bx bx-detail admicon"></i><br /> <h5 className="dashnewh">VIBHAG SUMMARY</h5>
                            </div>
                        </Link>
                    </Col>

                    <Col md={4}>
                        <Link to="/admin/list/JillaSummary/">
                            <div className="adminst">
                                <i className="bx bx-detail admicon"></i><br /> <h5 className="dashnewh">JILLA SUMMARY</h5>
                            </div>
                        </Link>
                    </Col>

                    <Col md={4}>
                        <Link to="/admin/list/KhandSummary/">
                            <div className="adminst">
                                <i className="bx bx-detail admicon"></i><br /> <h5 className="dashnewh">KHAND SUMMARY</h5>
                            </div>
                        </Link>
                    </Col>

                    <Col md={4}>
                        <Link to="/admin/list/SthanSummary/">
                            <div className="adminst">
                                <i className="bx bx-detail admicon"></i><br /> <h5 className="dashnewh">STHAN SUMMARY</h5>
                            </div>
                        </Link>
                    </Col>
                    <Col md={4}>
                        <Link to="/admin/list/ArthiksakhaSummary/">
                            <div className="adminst">
                                <i className="bx bx-detail admicon"></i><br /> <h5 className="dashnewh">Arthiksakha SUMMARY</h5>
                            </div>
                        </Link>
                    </Col>
                    {/* <Col md={4}>
                    <Link to="/admin/list/gurudakshina">
                        <div className="adminst">
                            <i className="bx bx-dollar-circle  admicon"></i><br /> <h5 className="dashnewh">GURUDAKSHINA LIST</h5>
                        </div>
                        </Link>
                    </Col> */}
                    {/* <Col md={4}>
                    <Link to="/admin/list/GurudakshinaSummary/">
                    <div className="adminst">
                        <i className="bx bx-detail admicon"></i><br /> <h5 className="dashnewh">GURUDAKSHINA SUMMARY REPORT</h5>
                    </div>
                    </Link>
                    </Col> */}
                    <Col md={4}>
                        <Link to="/admin/add/user">
                            <div className="adminst">
                                <strong><i className="bx bxs-user icon admicon"></i><br /></strong> <h5 className="dashnewh">ADD USER</h5>
                            </div>
                        </Link>
                    </Col>
                    {/* <Col md={4}>
                    <Link to="/admin/add/AddSthanUser">
                        <div className="adminst">
                            <strong><i className="bx bxs-user icon admicon"></i><br /></strong> <h5 className="dashnewh">ADD STHAN USER</h5> 
                        </div>
                        </Link>
                    </Col> */}


                </Row>
                {/* <Row>
            <Col md={12}>
            <div className="flexGrow adminbut">
                <button onClick={signOut} className="adminsign">Sign Out</button>
            </div>
            </Col>
            </Row> */}





                {/* <Link to="/editor">Go to the Editor page</Link>
            <br />
            <Link to="/admin">Go to the Admin page</Link>
            <br />
            <Link to="/lounge">Go to the Lounge</Link>
            <br />
            <Link to="/linkpage">Go to the link page</Link> */}
                {/* <div className="flexGrow">
                <button onClick={signOut}>Sign Out</button>
            </div> */}


            </section>
            <TopBar />
        </Container>
    )
}

export default Dashboard
